import { Link } from 'react-router-dom';

import { LoginForm } from '@/components/LoginForm';

import { LoginBackdrop } from '../LoginBackdrop';
import {
  AuthMeta,
  CapabilityRow,
  Eyebrow,
  Headline,
  LOGIN_SUBCOPY,
  LoginVariantProps,
  RavenWordmark
} from '../loginContent';

/**
 * Centered Split. A symmetric two-column split: the value proposition is
 * centered on both axes and center-aligned in the left half; the sign-in card
 * is centered in the right half. On mobile the left panel collapses to a
 * compact centered lockup above the form.
 */
export function CenteredSplit(props: LoginVariantProps) {
  const { error, providers, onPasswordSignIn, onOAuthSignIn } = props;

  return (
    <div className="relative grid min-h-svh lg:grid-cols-2">
      <Link
        to="/welcome"
        aria-label="Back to welcome"
        className="absolute left-6 top-6 z-20 hidden lg:flex"
      >
        <RavenWordmark />
      </Link>

      <section className="relative hidden flex-col items-center justify-center overflow-hidden border-r border-border/50 px-10 text-center lg:flex">
        <LoginBackdrop watermark="center" />
        <div className="relative z-10 flex max-w-md flex-col items-center gap-6">
          <Eyebrow />
          <Headline className="text-5xl xl:text-6xl" />
          <p className="text-base leading-relaxed text-muted-foreground">
            {LOGIN_SUBCOPY}
          </p>
          <CapabilityRow className="justify-center pt-2" />
        </div>
      </section>

      <section className="relative flex items-center justify-center overflow-hidden px-6 py-12">
        <LoginBackdrop className="lg:hidden" />
        <div className="relative z-10 w-full max-w-md">
          <div className="mb-8 flex flex-col items-center gap-4 text-center lg:hidden">
            <Link to="/welcome" aria-label="Back to welcome">
              <RavenWordmark className="justify-center" />
            </Link>
            <Eyebrow />
            <Headline className="text-4xl" />
          </div>

          <div className="rounded-2xl border border-border/60 bg-card/70 p-8 shadow-2xl shadow-black/40 backdrop-blur-xl">
            <LoginForm
              heading="Sign in"
              error={error}
              callbackUrl="/"
              providers={providers}
              onPasswordSignIn={onPasswordSignIn}
              onOAuthSignIn={onOAuthSignIn}
            />
          </div>

          <AuthMeta className="mt-7" />
        </div>
      </section>
    </div>
  );
}
